"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _styles = _interopRequireDefault(require("./styles"));

var _core = require("@emotion/core");

var Button =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Button, _React$PureComponent);

  function Button() {
    (0, _classCallCheck2.default)(this, Button);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Button).apply(this, arguments));
  }

  (0, _createClass2.default)(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          uia = _this$props.uia,
          innerRef = _this$props.innerRef,
          id = _this$props.id,
          type = _this$props.type,
          ref = _this$props.ref,
          leadingIcon = _this$props.leadingIcon,
          trailingIcon = _this$props.trailingIcon,
          restProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "disabled", "onClick", "uia", "innerRef", "id", "type", "ref", "leadingIcon", "trailingIcon"]);
      var onClickAction = disabled ? undefined : onClick;
      return (0, _core.jsx)(HtmlButton, (0, _extends2.default)({
        role: "button",
        id: id,
        "data-uia-button-disabled": disabled,
        "data-uia-button": uia,
        className: className,
        onClick: onClickAction,
        ref: innerRef,
        disabled: disabled,
        type: type
      }, restProps), (0, _core.jsx)(ButtonContainer, null, leadingIcon && (0, _core.jsx)(IconWrapper, {
        padRight: true
      }, leadingIcon), children, trailingIcon && (0, _core.jsx)(IconWrapper, null, trailingIcon)));
    }
  }]);
  return Button;
}(_react.default.PureComponent);

Button.defaultProps = {
  color: 'ctaPrimary',
  fontColor: 'light',
  fullWidth: false,
  size: 'medium',
  type: 'button',
  leadingIcon: null,
  trailingIcon: null
};
var HtmlButton = (0, _theme.styled)('button')(function () {
  return {
    paddingTop: '0px',
    paddingBottom: '0px',
    // reset browser agent button style
    WebkitTapHighlightColor: 'transparent'
  };
}, _styles.default.getBaseStyle, _styles.default.getBlockStyle, _styles.default.getCircleButtonStyle, _styles.default.getDefaultFocusstyles, _styles.default.getFocusStyles); // why I have to add a div instead just add flex to button?
// see https://github.com/philipwalton/flexbugs#flexbug-9

var ButtonContainer = (0, _theme.styled)('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  whiteSpace: 'pre' // to mimic the noWrap of button

});
var IconWrapper = (0, _theme.styled)('span')(function (_ref) {
  var theme = _ref.theme,
      padRight = _ref.padRight;

  if (padRight) {
    return {
      marginRight: theme.space.xsmall
    };
  } else {
    return {
      marginLeft: theme.space.xsmall
    };
  }
});
/**
 * @component
 */

var _default = Button;
exports.default = _default;